import { render, staticRenderFns } from "./displayConfig.vue?vue&type=template&id=7a2b0101&scoped=true&"
import script from "./displayConfig.ts?vue&type=script&lang=ts&"
export * from "./displayConfig.ts?vue&type=script&lang=ts&"
import style0 from "./displayConfig.vue?vue&type=style&index=0&id=7a2b0101&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b0101",
  null
  
)

export default component.exports